<div class="admin-layout">
    <nav>
        <a
            routerLink="themes"
            routerLinkActive="admin-layout__tab--active"
            class="admin-layout__tab"
        >
            Theme Management
        </a>
        <a
            routerLink="tenants"
            routerLinkActive="admin-layout__tab--active"
            class="admin-layout__tab"
        >
            Tenant Management
        </a>
        <a
            routerLink="users"
            routerLinkActive="admin-layout__tab--active"
            class="admin-layout__tab"
        >
            User Management
        </a>
    </nav>
    <router-outlet></router-outlet>
</div>
